import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DevicesComponent} from './components/devices/devices.component';
import {DeviceCategoriesComponent} from './components/device-categories/device-categories.component';
import {OrganizationsComponent} from './components/organizations/organizations.component';
import {DecodersComponent} from './components/decoders/decoders.component';
import {DevicesDetailsComponent} from './components/devices/devices-details/devices-details.component';
import {AssetsComponent} from './components/assets/assets.component';
import {TenantsComponent} from './components/tenants/tenants.component';
import {AssetsDetailsComponent} from './components/assets/assets-details/assets-details.component';
import {MapComponent} from './components/map/map.component';
import {LandingComponent} from './components/landing/landing.component';
import {TenantDetailsComponent} from './components/tenants/tenant-details/tenant-details.component';
import {DevicesFormComponent} from './components/devices/devices-form/devices-form.component';
import {AssetsFormComponent} from './components/assets/assets-form/assets-form.component';
import {TriggersComponent} from './components/triggers/triggers.component';
import {TriggerRulesComponent} from './components/trigger-rules/trigger-rules.component';
import {TraceabilityComponent} from './components/traceability/traceability.component';
import {SubscriptionsComponent} from './components/subscriptions/subscriptions.component';
import {StatisticsComponent} from './components/statistics/statistics.component';
import {TriggersFormComponent} from './components/triggers/triggers-form/triggers-form.component';
import {
  DeviceCategoriesFormComponent
} from './components/device-categories/device-categories-form/device-categories-form.component';
import {TenantsFormComponent} from './components/tenants/tenants-form/tenants-form.component';
import {DecodersFormComponent} from './components/decoders/decoders-form/decoders-form.component';
import {SubscriptionsFormComponent} from './components/subscriptions/subscriptions-form/subscriptions-form.component';
import {TriggerRulesFormComponent} from './components/trigger-rules/trigger-rules-form/trigger-rules-form.component';
import {OrganizationsFormComponent} from './components/organizations/organizations-form/organizations-form.component';
import {UsersComponent} from './components/users/users.component';
import {UsersFormComponent} from './components/users/users-form/users-form.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {MainComponent} from './main.component';
import {ADMIN, AuthGuard, OPERATOR, SUPER_ADMIN, VIEWER} from './common/auth-guard.service';
import {NotAuthorizedComponent} from './components/not-authorized/not-authorized.component';
import {PendingChangesGuard} from './common/can-deactivate/pending-changes-guard.service';
import {BeforeNavigationGuardService} from './common/can-deactivate/before-navigation-guard.service';
import {
  OrganizationsDetailsComponent
} from './components/organizations/organizations-details/organizations-details.component';
import {MeasurementTypesComponent} from './components/measurement-types/measurement-types.component';
import {
  MeasurementTypesFormComponent
} from './components/measurement-types/measurement-types-form/measurement-types-form.component';
import {AssetRepresentationsComponent} from './components/asset-representations/asset-representations.component';
import {
  AssetRepresentationsFormComponent
} from './components/asset-representations/asset-representations-form/asset-representations-form.component';
import {ApplicationsComponent} from './components/applications/applications.component';
import {
  ApplicationsFormComponent
} from './components/applications/external-applications-form/applications-form.component';
import {CepRulesComponent} from './components/cep-rules/cep-rules.component';
import {CepRulesFormComponent} from './components/cep-rules/cep-rules-form/cep-rules-form.component';
import {CepRulesDetailsComponent} from './components/cep-rules/cep-rules-details/cep-rules-details.component';
import {KpisComponent} from './components/kpis/kpis.component';
import {KpisFormComponent} from './components/kpis/kpis-form/kpis-form.component';
import {NettopoMapComponent} from './components/network-topology/nettopo-map.component';
import {KpisDetailsComponent} from './components/kpis/kpis-details/kpis-details.component';
import {SharedResourcesComponent} from './components/shared-resources/shared-resources.component';
import {
  SharedResourcesDetailsComponent
} from './components/shared-resources/shared-resources-details/shared-resources-details.component';
import {TemplatesComponent} from './components/templates/templates.component';
import {TemplatesFormComponent} from './components/templates/templates-form/templates-form.component';
import {TemplatesDetailsComponent} from './components/templates/templates-details/templates-details.component';
import {EncodersComponent} from './components/encoders/encoders.component';
import {EncodersFormComponent} from './components/encoders/encoders-form/encoders-form.component';
import {DevicesCsvComponent} from './components/devices/devices-csv/devices-csv.component';
import {CsvHistoryComponent} from './components/csv-history/csv-history.component';
import {ImportMeasurementsCsvComponent} from './components/import-measurements-csv/import-measurements-csv.component';
import {HwCatalogComponent} from './components/hw-catalog/hw-catalog.component';
import {
  DefaultMeasurementTypesFormComponent
} from './components/hw-catalog/default-measurement-types/default-measurement-types-form/default-measurement-types-form.component';
import {
  DefaultDeviceCategoriesFormComponent
} from './components/hw-catalog/default-device-categories/default-device-categories-form/default-device-categories-form.component';
import {
  DefaultPropertyTypesFormComponent
} from './components/hw-catalog/default-property-types/default-property-types-form/default-property-types-form.component';
import {
  DefaultAssetRepresentationsFormComponent
} from './components/hw-catalog/default-asset-representations/default-asset-representations-form/default-asset-representations-form.component';
import {
  DefaultDecodersFormComponent
} from './components/hw-catalog/default-decoders/default-decoders-form/default-decoders-form.component';
import {
  DefaultEncodersFormComponent
} from './components/hw-catalog/default-encoders/default-encoders-form/default-encoders-form.component';
import {
  DefaultDevicesDetailsComponent
} from './components/hw-catalog/default-devices/default-devices-details/default-devices-details.component';
import {
  DefaultDevicesFormComponent
} from './components/hw-catalog/default-devices/default-devices-form/default-devices-form.component';
import {DevicesRemovedComponent} from './components/devices-removed/devices-removed.component';

import {SynopticsComponent} from './components/synoptics/synoptics.component';
import {SynopticsFormComponent} from './components/synoptics/synoptics-form/synoptics-form.component';
import {SynopticDetailsComponent} from './components/synoptics/synoptic-details/synoptic-details.component';
import {AuditsComponent} from './components/audits/audits.component';
import {NotificationsComponent} from './components/notifications/notifications.component';
import {NotificationsFormComponent} from './components/notifications/notifications-form/notifications-form.component';
import {TriggersCsvComponent} from './components/triggers/triggers-csv/triggers-csv.component';
import {SequencesComponent} from './components/sequences/sequences.component';
import {SequenceFormComponent} from './components/sequences/sequences-form/sequence-form.component';

const routes: Routes = [
  {path: 'not-found', component: NotFoundComponent},
  {path: 'not-authorized', component: NotAuthorizedComponent},
  {path: '', component: MainComponent, children: [

      {path: '', component: LandingComponent, pathMatch: 'full'},

      {path: 'map', component: MapComponent , canActivate: [AuthGuard], canDeactivate: [BeforeNavigationGuardService], data: VIEWER},

      {path: 'assets', children: [
          {path: '', component: AssetsComponent, canActivate: [AuthGuard], data: VIEWER},
          {path: 'new', component: AssetsFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
          {path: ':uuid/measurements/import', component: ImportMeasurementsCsvComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
          {path: ':uuid/edit', component: AssetsFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
          {path: ':uuid/details', component: AssetsDetailsComponent, canActivate: [AuthGuard], data: VIEWER}
        ]},

      {path: 'devices', children: [
          {path: '', component: DevicesComponent, canActivate: [AuthGuard], data: VIEWER},
          {path: 'new', component: DevicesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
          {path: 'import', component: DevicesCsvComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
          {path: ':uuid/measurements/import', component: ImportMeasurementsCsvComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
          {path: ':uuid/edit', component: DevicesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: OPERATOR},
          {path: ':uuid/details', component: DevicesDetailsComponent, canActivate: [AuthGuard], data: VIEWER}
        ]},

      {path: 'kpis', children: [
          {path: '', component: KpisComponent, canActivate: [AuthGuard], data: VIEWER},
          {path: 'new', component: KpisFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: OPERATOR},
          {path: ':uuid/measurements/import', component: ImportMeasurementsCsvComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: OPERATOR},
          {path: ':uuid/edit', component: KpisFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: OPERATOR},
          {path: ':uuid/details', component: KpisDetailsComponent, canActivate: [AuthGuard], data: VIEWER}
        ]},

      {path: 'subscriptions', canActivate: [AuthGuard], data: ADMIN, children: [
          {path: '', component: SubscriptionsComponent},
          {path: 'new', component: SubscriptionsFormComponent, canDeactivate: [PendingChangesGuard]},
          {path: ':tenantUuid/:name/edit', component: SubscriptionsFormComponent, canDeactivate: [PendingChangesGuard]},
        ]},
      {path: 'notifications', canActivate: [AuthGuard], data: OPERATOR, children: [
          {path: '', component: NotificationsComponent},
          {path: 'new', component: NotificationsFormComponent, canDeactivate: [PendingChangesGuard], data: ADMIN},
          {path: ':tenantUuid/:name/edit', component: NotificationsFormComponent, canDeactivate: [PendingChangesGuard]},
        ]},

      {path: 'shared', canActivate: [AuthGuard], data: VIEWER, children: [
          {path: '', component: SharedResourcesComponent},
          {path: ':uuid/details', component: SharedResourcesDetailsComponent, canActivate: [AuthGuard]}
        ]},

      {path: 'applications', canActivate: [AuthGuard], data: SUPER_ADMIN, children: [
          {path: '', component: ApplicationsComponent},
          {path: 'new', component: ApplicationsFormComponent, canDeactivate: [PendingChangesGuard]},
          {path: ':applicationUuid/edit', component: ApplicationsFormComponent, canDeactivate: [PendingChangesGuard]}
        ]},

      {path: 'synoptics', canActivate: [AuthGuard], data: OPERATOR, children: [
          {path: '', component: SynopticsComponent},
          {path: 'new', component: SynopticsFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: ADMIN},
          {path: ':synopticUuid/edit', component: SynopticsFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: OPERATOR},
          {path: ':synopticUuid/details', component: SynopticDetailsComponent}
        ]},

      {path: 'system', children: [
          {path: 'templates', children: [
              {path: '', component: TemplatesComponent, canActivate: [AuthGuard], data: VIEWER},
              {path: 'new', component: TemplatesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
              {path: ':uuid/edit', component: TemplatesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
              {path: ':uuid/details', component: TemplatesDetailsComponent, canActivate: [AuthGuard], data: VIEWER}
            ]},
          {path: 'asset-representations', children: [
              {path: '', component: AssetRepresentationsComponent, canActivate: [AuthGuard], data: VIEWER},
              {path: 'new', component: AssetRepresentationsFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
              {path: ':tenantUuid/:name/edit', component: AssetRepresentationsFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
            ]},
          {path: 'device-categories', children: [
              {path: '', component: DeviceCategoriesComponent, canActivate: [AuthGuard], data: VIEWER},
              {path: 'new', component: DeviceCategoriesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
              {path: ':tenantUuid/:name/edit', component: DeviceCategoriesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
            ]},
          {path: 'sensor-types', children: [
              {path: '', component: MeasurementTypesComponent, canActivate: [AuthGuard], data: VIEWER},
              {path: 'new', component: MeasurementTypesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
              {path: ':tenantUuid/:sensor/edit', component: MeasurementTypesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
            ]},
          {path: 'decoders', children: [
              {path: '', component: DecodersComponent, canActivate: [AuthGuard], data: VIEWER},
              {path: 'new', component: DecodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
              {path: ':tenantUuid/:name/edit', component: DecodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
            ]},
          {path: 'encoders', children: [
              {path: '', component: EncodersComponent, canActivate: [AuthGuard], data: VIEWER},
              {path: 'new', component: EncodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
              {path: ':tenantUuid/:name/edit', component: EncodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: ADMIN},
            ]},
          {path: 'csv-history', children: [
              {path: '', component: CsvHistoryComponent, canActivate: [AuthGuard], data: VIEWER}
            ]},
          {path: 'hw-catalog', data: SUPER_ADMIN, children: [
              {path: '', component: HwCatalogComponent, canActivate: [AuthGuard]},
              {path: 'new', component: DefaultDevicesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: ':uuid/edit', component: DefaultDevicesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: ':uuid/details', component: DefaultDevicesDetailsComponent, canActivate: [AuthGuard]},
              {path: 'default-measurement-types/new', component: DefaultMeasurementTypesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-measurement-types/:sensor/:unit/edit', component: DefaultMeasurementTypesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-device-categories/new', component: DefaultDeviceCategoriesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-device-categories/:name/edit', component: DefaultDeviceCategoriesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-property-types/new', component: DefaultPropertyTypesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-property-types/:name/:unit/edit', component: DefaultPropertyTypesFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-asset-representations/new', component: DefaultAssetRepresentationsFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-asset-representations/:name/edit', component: DefaultAssetRepresentationsFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-decoders/new', component: DefaultDecodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-decoders/:name/edit', component: DefaultDecodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-encoders/new', component: DefaultEncodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]},
              {path: 'default-encoders/:name/edit', component: DefaultEncodersFormComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard]}
            ]},
          {path: 'devices-removed', children: [
              {path: '', component: DevicesRemovedComponent, canActivate: [AuthGuard], data: VIEWER}
            ]}
        ]},

      {path: 'alarms', children: [
          {
            path: 'triggers', canActivate: [AuthGuard], data: VIEWER, children: [
              {path: '', component: TriggersComponent},
              {path: 'import', component: TriggersCsvComponent, canActivate: [AuthGuard], canDeactivate: [PendingChangesGuard], data: OPERATOR},
              {path: 'new', component: TriggersFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: OPERATOR},
              {path: 'new/:entityType/:entityUuid/:tenantUuid/:organizationUuid', component: TriggersFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: OPERATOR},
              {path: ':entityType/:entityUuid/:entityMeasurementUuid/:triggerName/edit', component: TriggersFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: OPERATOR},
            ]},
          {
            path: 'trigger-rules', canActivate: [AuthGuard], data: VIEWER, children: [
              {path: '', component: TriggerRulesComponent, data: VIEWER},
              {path: 'new', component: TriggerRulesFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: OPERATOR},
              {path: ':tenantUuid/:organizationUuid/:name/edit', component: TriggerRulesFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: OPERATOR},
            ]},
          {
            path: 'cep-rules', canActivate: [AuthGuard], data: VIEWER, children: [
              {path: '', component: CepRulesComponent, data: VIEWER},
              {path: 'new', component: CepRulesFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: ADMIN},
              {path: ':tenantUuid/:organizationUuid/:name/edit', component: CepRulesFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: ADMIN},
              {path: ':tenantUuid/:organizationUuid/:name/details', component: CepRulesDetailsComponent, canActivate: [AuthGuard], data: VIEWER}
            ]}
        ]},

      {path: 'management', children: [
          {path: 'tenants', canActivate: [AuthGuard], data: SUPER_ADMIN, children: [
              {path: '', component: TenantsComponent},
              {path: 'new', component: TenantsFormComponent, canDeactivate: [PendingChangesGuard]},
              {path: ':uuid/edit', component: TenantsFormComponent, canDeactivate: [PendingChangesGuard]},
              {path: ':uuid/details', component: TenantDetailsComponent}
            ]},
          {path: 'organizations', canActivate: [AuthGuard], data: ADMIN, children: [
              {path: '', component: OrganizationsComponent},
              {path: 'new', component: OrganizationsFormComponent, canDeactivate: [PendingChangesGuard]},
              {path: ':uuid/edit', component: OrganizationsFormComponent, canDeactivate: [PendingChangesGuard]},
              {path: ':uuid/details', component: OrganizationsDetailsComponent, canActivate: [AuthGuard], data: VIEWER}
            ]},
          {path: 'users', canActivate: [AuthGuard], data: ADMIN, children: [
              {path: '', component: UsersComponent},
              {path: 'new', component: UsersFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: ADMIN},
              {path: ':uuid/:tenantUuid/edit', component: UsersFormComponent, canDeactivate: [PendingChangesGuard], canActivate: [AuthGuard], data: ADMIN}
            ]}
        ]},

      {path: 'monitoring', children: [
          {path: 'statistics', component: StatisticsComponent , canActivate: [AuthGuard], data: SUPER_ADMIN },
          {path: 'traceability', component: TraceabilityComponent , canActivate: [AuthGuard], data: SUPER_ADMIN },
          {path: 'network-topology', component: NettopoMapComponent, canActivate: [AuthGuard], data: SUPER_ADMIN},
          {path: 'audits', component: AuditsComponent, canActivate: [AuthGuard], data: ADMIN}
        ]
      },
      {path: 'sequences', canActivate: [AuthGuard], data: ADMIN, children: [
          {path: '', component: SequencesComponent},
          {path: 'new', component: SequenceFormComponent, canDeactivate: [PendingChangesGuard]},
          {path: ':sequenceUuid/edit', component: SequenceFormComponent, canDeactivate: [PendingChangesGuard]},
        ]},
      ],

  },
  {path: '**', redirectTo: '/not-found'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [ AuthGuard ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
